<template>
    <div class="userSetting-view">
        <div class="userSetting-header">
            <p v-for="(item,index) in activesType"
               :key="index"
               :class="{'checked-type': checkedActiveIndex === index }"
               @click="changeCheckedType(item,index)">
                {{ langTransfer(item.text) }}
                <i :style="{background: themeColor}"/>
            </p>
        </div>
        <div class="userSetting-body">
            <!-- <template v-if="checkedActiveIndex === 0">
                <div class="user-baseInfo-mask">
                    <div class="baseInfo-item">
                        <p>修改头像</p>
                        <img src="https://images.pexels.com/photos/1557183/pexels-photo-1557183.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" class="user-avatar">
                        <button class="upload-avatar-btn">上传头像</button>
                    </div>
                    <div class="baseInfo-item">
                        <p>登录账号</p>
                        <p>18811708621</p>
                    </div>
                    <div class="baseInfo-item">
                        <p>昵称</p>
                        <input type="text" placeholder="xxx的昵称">
                        <button class="sure-btn">确定</button>
                    </div>
                </div>
            </template> -->
            <template v-if="checkedActiveIndex === 0">
                <div class="changePassword-mask bindCard-mask">
                    <div class="changePassword-item">
                        <p>
                            {{ langTransfer('阅读卡号') }}
                        </p>
                        <input v-model="form.bindReadingCard.cardNo"
                               :placeholder="langTransfer('请输入阅读卡号')"
                               type="text">
                    </div>
                    <div class="warning-text">
                        {{ waringTexts.bindReadingCard }}
                    </div>
                    <button :style="{background: themeColor}"
                            class="sure-btn"
                            @click="bindCard">
                        {{ langTransfer('绑定') }}
                    </button>
                </div>
            </template>
            <template v-if="checkedActiveIndex === 1">
                <div class="changePassword-mask">
                    <div class="changePassword-item">
                        <p>
                            {{ langTransfer('原密码') }}
                        </p>
                        <input v-model="form.changePassword.oldpassword"
                               :placeholder="langTransfer('请输入原密码')"
                               type="text"
                               @focus="waringTexts.changePassword = ''">
                    </div>
                    <div class="changePassword-item">
                        <p>
                            {{ langTransfer('新密码') }}
                        </p>
                        <input v-model="form.changePassword.newpassword"
                               :placeholder="langTransfer('请输入新密码')"
                               type="text"
                               @focus="waringTexts.changePassword = ''">
                    </div>
                    <div class="changePassword-item">
                        <p>
                            {{ langTransfer('确认新密码') }}
                        </p>
                        <input v-model="form.changePassword.newpasswordSure"
                               :placeholder="langTransfer('请再次输入新密码')"
                               type="text"
                               @focus="waringTexts.changePassword = ''">
                    </div>
                    <div class="warning-text">
                        {{ waringTexts.changePassword }}
                    </div>
                    <button :style="{background: themeColor}"
                            class="sure-btn"
                            @click="changePassword">
                        {{ langTransfer('确认修改') }}
                    </button>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
        },
        props: {
        },
        data () {
            return {
                activesType: [
                    // {
                    //     text: '基本信息'
                    // },
                    {
                        text: '绑定阅读卡'
                    },
                    {
                        text: '修改密码'
                    }
                ],
                checkedActiveIndex: 0,
                form: {
                    changePassword: {
                        oldpassword: '',
                        newpassword: '',
                        newpasswordSure: ''
                    },
                    bindReadingCard: {
                        cardNo: ''
                    }
                },
                waringTexts: {
                    changePassword: '',
                    bindReadingCard: ''
                }
            }
        },
        computed: {
            userInfos () {
                return this.$store.state.userInfos
            },
            themeColor () {
                return this.$store.state.themeColor
            }
        },
        mounted () {
        },
        methods: {
            changeCheckedType (item, index) {
                if (this.checkedActiveIndex === index) {
                    return
                }
                this.checkedActiveIndex = index
            },
            async changePassword () {
                if (this.waringTexts.changePassword === '修改中...') {
                    return
                }
                try {
                    this.waringTexts.changePassword = '修改中...'
                    const { oldpassword, newpassword, newpasswordSure } = this.form.changePassword
                    if (!oldpassword || !newpassword || !newpasswordSure) {
                        this.waringTexts.changePassword = '有未完成选项，请确认输入'
                        return
                    }
                    if (newpassword !== newpasswordSure) {
                        this.waringTexts.changePassword = '两次输入的新密码不一致，请重新输入'
                        return
                    }
                    const formData = {
                        oldpassword,
                        newpassword
                    }
                    const data = await this.$apis('user').changePassword(formData)
                    if (data.Code === 1) {
                        this.waringTexts.changePassword = '修改成功...'
                        setTimeout(() => {
                            this.waringTexts.changePassword = ''
                            this.form.changePassword = {
                                oldpassword: '',
                                newpassword: '',
                                newpasswordSure: ''
                            }
                        }, 800)
                    } else {
                        this.waringTexts.changePassword = '修改失败，请稍后重试'
                    }
                } catch (error) {
                    const { Message } = error
                    this.waringTexts.changePassword = Message
                }
            },
            async bindCard () {
                if (this.waringTexts.bindReadingCard === '绑定中...') {
                    return
                }
                try {
                    this.waringTexts.bindReadingCard = '绑定中...'
                    const { UserID } = this.userInfos
                    const { cardNo } = this.form.bindReadingCard
                    const bindFormData = {
                        userIdentifier: UserID,
                        cardNo
                    }
                    const { Data } = await this.$apis('user').bindCard(bindFormData)
                    if (Data) {
                        this.waringTexts.bindReadingCard = '绑定完成'
                        setTimeout(() => {
                            window.location.reload()
                        }, 800)
                    }
                } catch (error) {
                    const { Message } = error
                    this.waringTexts.bindReadingCard = Message
                }
            }
        },
        beforeRouteEnter (to, from, next) {
            next((vm) => {
                const { userInfos } = vm.$store.state
                if (!userInfos) {
                    vm.$router.push({
                        path: '/'
                    })
                }
                vm.form = {
                    changePassword: {
                        oldpassword: '',
                        newpassword: '',
                        newpasswordSure: ''
                    },
                    bindReadingCard: {
                        cardNo: ''
                    }
                }
                vm.waringTexts.changePassword = ''
            })
        }
    }
</script>

<style lang="scss" scoped>
    .userSetting-view {
        width: 850px;
        box-sizing: border-box;
        overflow: hidden;
        background: #FFFFFF;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
    }

    .userSetting-header {
        width: 850px;
        height: 50px;
        box-sizing: border-box;
        padding-left: 16px;
        background: #fff;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        border-bottom: 1px solid #F0F2F7;

        p {
            
            font-size: 16px;
            color: #1A1A1A;
            line-height: 50px;
            margin-right: 30px;
            position: relative;
            cursor: pointer;

             i {
                display: block;
                width: 100%;
                height: 2px;
                position: absolute;
                bottom: 5px;
                left: 0;
                background: #0084FF;
                border-radius: 1px;
                opacity: 0;
                transition: all .1s;
            }
        }

        .checked-type {

            i {
                opacity: 1;
            }
        }
    }

    .userSetting-body {
        width: 100%;
        background: #fff;
    }

    .user-baseInfo-mask {
        width: 100%;
        box-sizing: border-box;
        padding: 34px;
    }

    .baseInfo-item {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;

        p {
            width: 56px;
            
            font-size: 14px;
            color: #484E58;
            letter-spacing: 0;
            margin-right: 12px;
        }

        .user-avatar {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-right: 20px;
        }

        .upload-avatar-btn {
            width: 77px;
            height: 26px;
            background: #0084FF;
            border-radius: 4px;
            
            font-size: 10px;
            color: #FFFFFF;
            letter-spacing: 0;
            line-height: 12px;
            cursor: pointer;
        }

        input {
            width: 360px;
            height: 36px;
            box-sizing: border-box;
            padding-left: 10px;
            background: #FFFFFF;
            border: 1px solid #C0CCDA;
            border-radius: 4px;
            
            font-size: 14px;
            color: #484E58;
            letter-spacing: 0;
            line-height: 14px;
            margin-right: 20px;
        }

        .sure-btn {
            
            font-size: 14px;
            color: #0084FF;
            letter-spacing: 0;
        }
    }

    .baseInfo-item:nth-child(1) {
        height: 40px;
    }

    .baseInfo-item:nth-child(2) {
        height: 14px;
        margin: 20px 0;
    }

    .baseInfo-item:nth-child(3) {
        height: 36px;
    }

    .changePassword-mask {
        width: 100%;
        box-sizing: border-box;
        padding: 34px;

        button {
            width: 136px;
            height: 38px;
            background: #0084FF;
            border-radius: 4px;
            
            font-size: 14px;
            color: #FFFFFF;
            letter-spacing: 0;
            line-height: 16px;
            margin-left: 86px;
        }
    }

    .changePassword-item {
        height: 36px;
        margin-bottom: 20px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;

        p {
            width: 70px;
            
            font-size: 14px;
            color: #484E58;
            letter-spacing: 0;
            margin-right: 16px;
        }

        input {
            width: 360px;
            height: 36px;
            box-sizing: border-box;
            padding-left: 16px;
            background: #FFFFFF;
            border: 1px solid #C0CCDA;
            border-radius: 4px;
            
            font-size: 14px;
            color: #8590A6;
            letter-spacing: 0;
        }
    }

    .changePassword-item:nth-child(3) {
        margin-bottom: 0;
    }

    .warning-text {
        padding-left: 86px;
        height: 30px;
        line-height: 30px;
        font-size: 12px;
        color: #e02433;
    }

    .bindCard-mask {

        .changePassword-item {
            margin-bottom: 0;
        }
    }
</style>
